import { Form } from './form';
import { OfflinePaymentView } from '../view/offline-payment-view';
import { FormTypes } from './form-types';
import { Order } from '../config/order';
import { OfflinePaymentValidator } from '../validators/offline-payment-validator';
import { PaymentType } from '../providers/payment-type';

export class OfflinePaymentForm extends Form {

    view: OfflinePaymentView = new OfflinePaymentView();
    type = FormTypes.OfflinePayment;
  
    constructor(step: number | null = null) {
        super();
        this.step = step;
        this.validators.push(new OfflinePaymentValidator());
    }

    render() {
        this.view.renderOfflinePaymentFormFragment();

        if (this.step) {
            this.hideForm();
        }

        return Promise.resolve();
    }

    submit(order: Order) {
        order.paymentMethod = {
            type: PaymentType.OFFLINE
        };

        return Promise.resolve(order);
    }

    postSubmit(submissionContext: any): Promise<any> {
        this.config.widget.triggerAppEvent('onFormSubmitted', submissionContext);
        this.config.widget.redirectOrMessage();
        return Promise.resolve();
    }

    showForm() {
        this.view.setVisible(true);
    }

    hideForm() {
        this.view.setVisible(false);
    }

}
